import {
  CLEAR_ACTIVE_ALARMS_COUNT,
  CLEAR_ALARMS_REDUCER,
  CLEAR_ALARM_MESSAGES,
  CLEAR_CALLS_HISTORY,
  GET_ACTIVE_ALARMS_COUNT_SUCCESS,
  GET_ALARMS_HISTORY_LIST,
  GET_ALARMS_HISTORY_LIST_ERROR,
  GET_ALARMS_HISTORY_LIST_SUCCESS,
  GET_ALARMS_HISTORY_MESSAGES,
  GET_ALARMS_HISTORY_MESSAGES_ERROR,
  GET_ALARMS_HISTORY_MESSAGES_SUCCESS,
  GET_ALARM_LIST,
  GET_ALARM_LIST_ERROR,
  GET_ALARM_LIST_SUCCESS,
  GET_ALARM_MESSAGE_LIST,
  GET_ALARM_MESSAGE_LIST_ERROR,
  GET_ALARM_MESSAGE_LIST_SUCCESS,
  SEARCH_CALLS_HISTORY,
  SEARCH_CALLS_HISTORY_FAILURE,
  SEARCH_CALLS_HISTORY_SUCCESS,
  SEND_ALARM_MESSAGE,
  SEND_ALARM_MESSAGE_SUCCESS,
  SEND_ALARM_MESSAGE_FAILURE,
  START_ALARM_CALL,
  START_ALARM_CALL_ERROR,
  START_ALARM_CALL_SUCCESS,
  STOP_ALARM_CALL,
  STOP_ALARM_CALL_ERROR,
  STOP_ALARM_CALL_SUCCESS,
  SET_ALARMS_HISTORY_FILTERS,
  SET_CALLS_HISTORY_FILTERS,
  CLEAR_ALARMS_HISTORY_REDUCER,
  CLEAR_ALARMS_HISTORY_FILTERS,
  CLEAR_CALLS_HISTORY_FILTERS,
} from '../constants/ActionTypes';
import { RequestStatus } from '../models/requestStatus';

const initialState = {
  alarms: {
    data: [],
    loading: false,
    pageCount: 0,
  },
  history: {
    data: [],
    loading: false,
    pageCount: 0,
    filters: {
      from: '',
      phoneNumber: '',
      route: '',
      to: '',
      type: '',
      userStarted: '',
      userStopped: '',
    },
  },
  calls: {
    data: [],
    loading: false,
    pageCount: 0,
    filters: {
      alarmId: '',
      endTime: '',
      from: '',
      startTime: '',
      to: '',
    },
  },
  messages: {
    data: [],
    isLoading: false,
  },
  alarmsCallsLoadingStatuses: [],
  lastMessageSent: null,
  activeAlarmsCount: null,
};

/* shape for 'alarmsCallsLoadingStatuses'
* alarmsCallsLoadingStatuses: [{
* alarmId: string,
* responseStatus: one of CALL_SESSION_STATUSES,
* requestStatus: RequestStatus,
* }]
* */

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ACTIVE_ALARMS_COUNT:
      return {
        ...state,
        activeAlarmsCount: 0,
      };
    case CLEAR_ALARMS_REDUCER:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          data: [],
          loading: false,
          pageCount: 0,
        },
        activeAlarmsCount: state.activeAlarmsCount,
      };
    case CLEAR_ALARM_MESSAGES:
      return {
        ...state,
        messages: {
          ...state.messages,
          data: [],
        },
      };
    case CLEAR_ALARMS_HISTORY_FILTERS:
      return {
        ...state,
        history: {
          ...state.history,
          filters: {
            from: '',
            phoneNumber: '',
            route: '',
            to: '',
            type: '',
            userStarted: '',
            userStopped: '',
          },
        },
      };
    case CLEAR_ALARMS_HISTORY_REDUCER:
      return {
        ...state,
        history: {
          ...state.history,
          data: [],
          loading: false,
          pageCount: 0,
          filters: {
            from: '',
            phoneNumber: '',
            route: '',
            to: '',
            type: '',
            userStarted: '',
            userStopped: '',
          },
        },
      };
    case CLEAR_CALLS_HISTORY_FILTERS:
      return {
        ...state,
        calls: {
          ...state.calls,
          filters: {
            from: '',
            phoneNumber: '',
            route: '',
            to: '',
            type: '',
            userStarted: '',
            userStopped: '',
          },
        },
      };
    case CLEAR_CALLS_HISTORY:
      return {
        ...state,
        calls: {
          ...state.calls,
          data: [],
          loading: false,
          pageCount: 0,
        },
      };
    case GET_ACTIVE_ALARMS_COUNT_SUCCESS:
      return {
        ...state,
        activeAlarmsCount: action.payload.activeAlarmsCount,
      };
    case GET_ALARMS_HISTORY_LIST:
      return {
        ...state,
        history: {
          ...state.history,
          loading: true,
        },
      };
    case GET_ALARMS_HISTORY_LIST_ERROR:
      return {
        ...state,
        history: {
          ...state.history,
          loading: false,
        },
      };
    case GET_ALARMS_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        history: {
          ...state.history,
          data: action.payload.alarmsHistory,
          loading: false,
          pageCount: action.payload.pageCount,
        },
      };
    case GET_ALARMS_HISTORY_MESSAGES:
      return {
        ...state,
        messages: {
          ...state.messages,
          isLoading: true,
        },
      };
    case GET_ALARMS_HISTORY_MESSAGES_ERROR:
      return {
        ...state,
        messages: {
          ...state.messages,
          data: [],
          isLoading: false,
        },
      };
    case GET_ALARMS_HISTORY_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: {
          ...state.messages,
          data: action.payload.messages,
          isLoading: false,
        },
      };
    case SET_ALARMS_HISTORY_FILTERS:
      return {
        ...state,
        history: {
          ...state.history,
          filters: {
            ...state.history.filters,
            ...action.payload,
          },
        },
      };
    case GET_ALARM_LIST:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          loading: true,
        },
      };
    case GET_ALARM_LIST_ERROR:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          loading: false,
        },
      };
    case GET_ALARM_LIST_SUCCESS:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          data: action.payload.alarms,
          loading: false,
          pageCount: action.payload.pageCount,
        },
      };
    case GET_ALARM_MESSAGE_LIST:
      return {
        ...state,
        messages: {
          ...state.messages,
          isLoading: true,
        },
      };
    case GET_ALARM_MESSAGE_LIST_ERROR:
      return {
        ...state,
        messages: {
          ...state.messages,
          data: [],
          isLoading: false,
        },
      };
    case GET_ALARM_MESSAGE_LIST_SUCCESS:
      return {
        ...state,
        messages: {
          ...state.messages,
          data: action.payload.messages,
          isLoading: false,
        },
      };
    case SET_CALLS_HISTORY_FILTERS:
      return {
        ...state,
        calls: {
          ...state.calls,
          filters: {
            ...state.calls.filters,
            ...action.payload,
          },
        },
      };
    case SEARCH_CALLS_HISTORY:
      return {
        ...state,
        calls: {
          ...state.calls,
          loading: true,
        },
      };
    case SEARCH_CALLS_HISTORY_FAILURE:
      return {
        ...state,
        calls: {
          ...state.calls,
          data: [],
          pageCount: 1,
          loading: false,
        },
      };
    case SEARCH_CALLS_HISTORY_SUCCESS:
      return {
        ...state,
        calls: {
          ...state.calls,
          data: action.payload.calls,
          pageCount: action.payload.pageCount,
          loading: false,
        },
      };
    case SEND_ALARM_MESSAGE:
      return {
        ...state,
        messages: {
          ...state.messages,
          isLoading: true,
        },
      };
    case SEND_ALARM_MESSAGE_SUCCESS:
      return {
        ...state,
        lastMessageSent: Date.now(),
        messages: {
          ...state.messages,
          isLoading: false,
        },
      };
    case SEND_ALARM_MESSAGE_FAILURE:
      return {
        ...state,
        messages: {
          ...state.messages,
          isLoading: false,
        },
      };
    case START_ALARM_CALL:
    case STOP_ALARM_CALL: {
      let { alarmsCallsLoadingStatuses } = state;

      const isOldStatus = alarmsCallsLoadingStatuses.some(
        loadStatus => loadStatus.alarmId === action.payload.alarmId,
      );

      // we should check if previous loading status stored here
      if (isOldStatus) {
        alarmsCallsLoadingStatuses = alarmsCallsLoadingStatuses.map(loadStatus => {
          if (loadStatus.alarmId === action.payload.alarmId) {
            return {
              ...loadStatus,
              responseStatus: undefined,
              requestStatus: new RequestStatus(true),
            };
          }
          return loadStatus;
        });
      } else {
        alarmsCallsLoadingStatuses = [
          ...alarmsCallsLoadingStatuses,
          {
            alarmId: action.payload.alarmId,
            responseStatus: undefined,
            requestStatus: new RequestStatus(true),
          },
        ];
      }

      return {
        ...state,
        alarmsCallsLoadingStatuses,
      };
    }
    case START_ALARM_CALL_ERROR:
    case STOP_ALARM_CALL_ERROR: {
      const alarmsCallsLoadingStatuses = state.alarmsCallsLoadingStatuses.map(loadStatus => {
        if (loadStatus.alarmId === action.payload.alarmId) {
          return {
            ...loadStatus,
            responseStatus: undefined,
            requestStatus: new RequestStatus(false, false, action.payload.error),
          };
        }
        return loadStatus;
      });

      return {
        ...state,
        alarmsCallsLoadingStatuses,
      };
    }
    case START_ALARM_CALL_SUCCESS:
    case STOP_ALARM_CALL_SUCCESS: {
      const alarmsCallsLoadingStatuses = state.alarmsCallsLoadingStatuses.map(loadStatus => {
        if (loadStatus.alarmId === action.payload.alarmId) {
          return {
            ...loadStatus,
            responseStatus: action.payload.responseStatus,
            requestStatus: new RequestStatus(false, true),
          };
        }
        return loadStatus;
      });

      return {
        ...state,
        alarmsCallsLoadingStatuses,
      };
    }
    default: {
      return state;
    }
  }
};
